import React from "react";
import Loading from "components/Common/Mobile/Loading";

const LoadingPage = () => <Loading></Loading>;

export default LoadingPage;
